export default __webpack_public_path__ + "static/media/happy-puppy.5495882c2f8cd99af140a6b4207298ca.jpg";